/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * InvitingUserDtoBase
 * auto generated base class for the model InvitingUserDtoModel.
 */
export const InvitingUserDtoModelBase = ModelBase
  .named('InvitingUserDto')
  .props({
    __typename: types.optional(types.literal("InvitingUserDto"), "InvitingUserDto"),
    fullname: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class InvitingUserDtoModelSelector extends QueryBuilder {
  get fullname() { return this.__attr(`fullname`) }
}
export function selectFromInvitingUserDto() {
  return new InvitingUserDtoModelSelector()
}

export const invitingUserDtoModelPrimitives = selectFromInvitingUserDto().fullname
